import { defineComponent as n, mergeModels as p, useModel as u, openBlock as i, createBlock as d, unref as s, normalizeClass as m, withCtx as f, renderSlot as l, withDirectives as c, createElementVNode as v, mergeProps as V, vModelText as y } from "vue";
import g from "../../../private/InputContainer/v-input-container.vue2.js";
/* empty css                                                    */
const q = /* @__PURE__ */ n({
  __name: "v-text-input",
  props: /* @__PURE__ */ p({
    placeholder: {},
    autocomplete: {},
    name: {},
    pattern: {},
    required: { type: Boolean },
    color: {},
    defaultValue: {},
    value: {},
    applyValidation: { type: Boolean },
    validator: { type: Function }
  }, {
    modelValue: {
      default: ""
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(a) {
    const o = u(a, "modelValue");
    return (e, t) => (i(), d(s(g), {
      class: m([e.color])
    }, {
      default: f(() => [
        l(e.$slots, "prefix"),
        c(v("input", V({
          class: "v-input",
          type: "text",
          "onUpdate:modelValue": t[0] || (t[0] = (r) => o.value = r)
        }, {
          placeholder: e.placeholder,
          autocomplete: e.autocomplete,
          name: e.name,
          pattern: e.pattern instanceof RegExp ? e.pattern.toString() : e.pattern,
          required: e.required
        }), null, 16), [
          [y, o.value]
        ]),
        l(e.$slots, "suffix")
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  q as default
};
